// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"230":"17692e5f","359":"01825014","429":"01825014","514":"01825014"}[chunkId] + ".chunk.css";
};